"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUsesToggle = exports.usesToggle = exports.getUsesToggleSerializer = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const _1 = require(".");
function getUsesToggleSerializer() {
    return (0, serializers_1.dataEnum)([
        ['None', (0, serializers_1.unit)()],
        ['Clear', (0, serializers_1.unit)()],
        [
            'Set',
            (0, serializers_1.struct)([
                ['fields', (0, serializers_1.tuple)([(0, _1.getUsesSerializer)()])],
            ]),
        ],
    ], { description: 'UsesToggle' });
}
exports.getUsesToggleSerializer = getUsesToggleSerializer;
function usesToggle(kind, data) {
    return Array.isArray(data)
        ? { __kind: kind, fields: data }
        : { __kind: kind, ...(data ?? {}) };
}
exports.usesToggle = usesToggle;
function isUsesToggle(kind, value) {
    return value.__kind === kind;
}
exports.isUsesToggle = isUsesToggle;
//# sourceMappingURL=usesToggle.js.map